'use strict';
import axios from 'axios';

export default function() {
  $('.geo-prompt-modal--dismiss-button').click(async function() {
    $('.geo-prompt-modal').css('display', 'none');
    const endpointUrl = '/set-location-prompt-cookie';
    await axios.post(endpointUrl);
  });

  $(document).ready(function() {
    $('#geoPromptModal').appendTo('.header-wrap');
  });
}
